import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.loadCalendar();
  }

  loadCalendar() {
    const url = this.element.dataset.url;
    fetch(url, {
      method: "GET",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/javascript"
      },
    })
      .then(response => response.text())
      .then(js => eval(js))
      .catch(error => console.error("Error loading calendar:", error));
  }
}
